import { jsx } from "react/jsx-runtime";
import { Trigger, Flex, Text, FONT_TYPES, TriggerText, ModalDialog, Paragraph, Heading } from "@zillow/constellation";
import { event } from "@zillow/universal-analytics";
import PropTypes from "prop-types";
import "react";
const LegalPopover = ({
  text,
  triggerText,
  interactionEventCmsInfo,
  className,
  style
}) => {
  const onOpenInteractionEvent = interactionEventCmsInfo ? {
    envelope: {
      event_type_id: "5030",
      event_type_version_id: "1",
      event_template_id: "297",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_modal",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_open"
    },
    cms_info: interactionEventCmsInfo
  } : null;
  const onCloseInteractionEvent = interactionEventCmsInfo ? {
    envelope: {
      event_type_id: "2051",
      event_type_version_id: "1",
      event_template_id: "126",
      event_template_version_id: "1"
    },
    clickstream_trigger: {
      trigger_type_nm: "interaction",
      trigger_location_nm: "cms",
      trigger_source_nm: "cms_modal",
      trigger_object_nm: "no_trigger_object"
    },
    semantic: {
      semantic_event_nm: "cms_close"
    },
    cms_info: interactionEventCmsInfo
  } : "";
  return /* @__PURE__ */ jsx(Trigger, { triggered: /* @__PURE__ */ jsx(ModalDialog, { wide: true, header: /* @__PURE__ */ jsx(Heading, { level: 2, children: "Calculator Disclaimer" }), body: /* @__PURE__ */ jsx(Paragraph, { children: text }) }), onOpen: () => event(onOpenInteractionEvent), onClose: () => event(onCloseInteractionEvent), children: /* @__PURE__ */ jsx(Flex, { marginY: "sm", display: "flex", justifyContent: "flex-end", className, style, children: /* @__PURE__ */ jsx(Text, { fontType: FONT_TYPES.bodySmall, children: /* @__PURE__ */ jsx(TriggerText, { children: triggerText }) }) }) });
};
LegalPopover.propTypes = {
  text: PropTypes.string,
  triggerText: PropTypes.string,
  interactionEventCmsInfo: PropTypes.object,
  style: PropTypes.object,
  className: PropTypes.string
};
export {
  LegalPopover as default
};
